import {takeEvery} from 'redux-saga/effects'

import {
  ADD_EMERGENCY_CONTACTS,
  ADD_PARENT,
  DELETE_CHILDLESS_PARENTS,
  EMAIL_PARENT_LOGIN_DETAILS,
  GENERATE_PARENT_LOGIN_REPORT,
  GENERATE_PARENT_SIBLING_REPORT_PDF,
  GET_EMERGENCY_LIST_ID,
  GET_PARENT_BY_ID,
  GET_PARENT_CHILDREN_LIST,
  GET_PARENT_LIST,
  SMS_PARENT_LOGIN_DETAILS,
  UPDATE_PARENT,
} from '../../../Actions/School/Parent/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_PARENT_LIST, fetchData)
  yield takeEvery(GET_PARENT_BY_ID, fetchData)
  yield takeEvery(GET_PARENT_CHILDREN_LIST, fetchData)
  yield takeEvery(GET_EMERGENCY_LIST_ID, fetchData)
  yield takeEvery(ADD_PARENT, fetchData)
  yield takeEvery(UPDATE_PARENT, fetchData)
  yield takeEvery(ADD_EMERGENCY_CONTACTS, fetchData)
  yield takeEvery(GENERATE_PARENT_LOGIN_REPORT, fetchData)
  yield takeEvery(SMS_PARENT_LOGIN_DETAILS, fetchData)
  yield takeEvery(EMAIL_PARENT_LOGIN_DETAILS, fetchData)
  yield takeEvery(GENERATE_PARENT_SIBLING_REPORT_PDF, fetchData)
  yield takeEvery(DELETE_CHILDLESS_PARENTS, fetchData)
}

export default dataSaga
